import { render, staticRenderFns } from "./ListTenantPage.vue?vue&type=template&id=5f6d29d5&"
import script from "./ListTenantPage.vue?vue&type=script&lang=js&"
export * from "./ListTenantPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports